module.exports = __webpack_public_path__ + "img/mir_sc.b497e04.svg";